export const formatDateForInput = (dateString?: string | null) => {
  if (!dateString) return "";

  const dateOnlyMatch = dateString.match(/^\d{4}-\d{2}-\d{2}/);
  if (dateOnlyMatch) {
    return dateOnlyMatch[0];
  }

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) {
    return "";
  }

  return date.toISOString().split("T")[0];
};

export const isExpired = (expirationDate?: string): boolean => {
  if (!expirationDate) return false;
  const now = new Date();
  const expDate = new Date(expirationDate);
  return now > expDate;
};
